<template>
	<div class="prodictImageswap">
	<!-- v-model="slide"  -->
	<b-carousel id="carousel-1" :interval="intervalSlider" controls indicators  background="#fff" img-width="590px" img-height="200px" style="text-shadow: 1px 1px 2px #333;"
      :no-hover-pause=true >
					 <b-carousel-slide >
							<template #img >
							<b-link href="/brand/mermaid">
							  <b-img :src="$root.MEDIAPATH+'banners/mermaid.jpg'" fluid ></b-img>
							  </b-link>
							</template>
					  </b-carousel-slide>
					  <b-carousel-slide >
						<template #img >
						<b-link href="/brand/embark">
						  <b-img :src="$root.MEDIAPATH+'banners/embark.jpg'" fluid ></b-img>
						  </b-link>
						</template>
					  </b-carousel-slide>
					  
					  <b-carousel-slide >
						<template #img >
						<b-link href="/brand/myra-veda">
						  <b-img :src="$root.MEDIAPATH+'banners/myra-veda.jpg'" fluid
							alt="image slot"></b-img>
						  </b-link>
						</template>
					  </b-carousel-slide>
					  
					  
						
                     
					
                       <!-- <b-carousel-slide :img-src="$root.MEDIAPATH+'banners/17a0e514-2928-418d-9050-f6e661a1ccab.jpg'"></b-carousel-slide>
						<b-carousel-slide :img-src="$root.MEDIAPATH+'banners/45c0461d-fb33-4a9f-b9fb-107d36c85153.jpg'"></b-carousel-slide>  -->
                    </b-carousel>
	
	
	
		
   </div>
    
</template>

<script>
//import AddtocartButton from "@/components/addtocartButton.vue";
export default {
  name: 'Quickview',
  props: {
    galleryimages: { type: Array }
  },
  components: {
  //"addtocart-button": AddtocartButton,
  },
  mounted(){
    //this.heading = "Related Products";
  },
  computed: {
   
  },
  data() {
  
    return{
		//thumbnailProps: { blank: false, fluidGrow: true, width: 360, height: 400,class: 'm1' },
		intervalSlider:4000,
		 fullWidthImage: false,
    }
  },
  methods:{
		zoomMe(event){
		
		console.log('Zoom me'+event.width);
		}
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.prodictImageswap{
		margin-bottom: 27px;
		/*height:405px;*/
		.carousel-indicators {
		
		
			bottom: -35px;
			z-index: unset;
			width: 100%;
			margin-left: 0px;
			li{
				    width: 6px;
					height: 6px;
					 border-radius: 100%;
					 background-color: #000;
					 z-index: 0;
					 margin: 0px 6px;
					 border: 1px solid #fff;
				/* &:focus{ border:2px solid red;
				}*/
			}
			
			
			.expand { width:23em;/* height: 25em;*/ border:1px solid red;}
				
			
		}
		.carousel-control-next{ display:none;}
		.carousel-control-prev{ display:none;}
			 
		.carousel-item{

				box-shadow: 0 2px 3px 0 rgb(0 0 0 / 10%);
				transition: box-shadow linear 0.2s;
				padding: 10px;
				background-color: #fff;
				:hover{
				
				}
			}
		
		.fullImage {
			  width: 200%;
			  height: auto;
			}
	
		/*.swiper-wrapper{
			.padding:0px;
			.swiper-slide{
				padding:0px;
				background-color: unset;
			}
		}
		.productigDisplay{
			max-width: 100%;
			height: 400px;
		} */
		
		.img-fluid{
		    max-width: 100%;
			height: 400px;
		}
		.w-100{
			width: auto !important;
		}
	}
	/*.swiper-priceinfo{
				min-height: 45px;
	}
			  
  .swiper-button-lock {
	display:block !important;
  } */

</style>
